import { getUser } from '../services/session';

import * as sessionActions from '../actions/session';

const initialState = {
    user: getUser(),
    requiresConfirmation: false
};

export default (state = initialState, action) => {
    switch (action.type) {

        case sessionActions.SET_SESSION_USER:
            return {
                ...state,
                user: action.user
            };

        case sessionActions.REQUIRES_CONFIRMATION_CHANGED:
            return {
                ...state,
                requiresConfirmation: action.requiresConfirmation
            };

        default:
            return state;
    }
};